<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap;line-height: 2.5;">
Cập nhật lần cuối: 13/04/2026 <br>
Chào mừng bạn đến với Lavi Finance, được vận hành bởi VIETNAM INTERNATIONAL COMMERCIAL JOINT STOCK BANK - ASSET MANAGEMENT COMPANY LIMITED (VIB AMC).
Chính sách bảo mật này quy định cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân của khách hàng, người dùng và khách truy cập (sau đây gọi là "Bạn" hoặc "Chủ sở hữu dữ liệu") khi sử dụng ứng dụng di động Lavi Finance và các dịch vụ liên quan (sau đây gọi là "Nền tảng"). Bằng việc truy cập hoặc sử dụng Nền tảng, bạn đồng ý với các điều khoản trong Chính sách này.

<h2> THÔNG BÁO VỀ VIỆC CHUYỂN ĐỔI HỆ THỐNG VÀ DỮ LIỆU</h2>
Chào Bạn, để nâng cao chất lượng dịch vụ và đảm bảo tính pháp lý cao nhất tại thị trường Việt Nam, Lavi Finance đã thực hiện một bước tiến quan trọng trong việc nâng cấp hệ thống:

<h3> 1. Chuyển đổi pháp nhân vận hành</h3>
Toàn bộ nền tảng Lavi Finance hiện đã được chuyển giao và vận hành chính thức bởi Công ty TNHH MTV Quản lý nợ và Khai thác tài sản Ngân hàng TMCP Quốc tế Việt Nam (VIB AMC). Việc thay đổi này giúp đảm bảo các quyền lợi tài chính của bạn được bảo vệ bởi một tổ chức uy tín tại địa phương.

<h3> 2. Chuyển đổi máy chủ và Di trú dữ liệu</h3>
Chúng tôi đã thực hiện di chuyển toàn bộ cơ sở dữ liệu từ máy chủ cũ (lavifinance.com) sang hệ thống máy chủ mới đạt chuẩn bảo mật ngân hàng tại địa chỉ: https://www.lavifinance.com.
- Mục đích: Tập trung hóa dữ liệu, tăng tốc độ truy xuất và tuân thủ quy định về lưu trữ dữ liệu người dùng tại Việt Nam.
- An toàn dữ liệu: Quá trình di chuyển được thực hiện thông qua đường truyền mã hóa quân đội, đảm bảo không có sự rò rỉ hoặc mất mát thông tin cá nhân hay lịch sử giao dịch của bạn.

<h3> 3. Bạn cần làm gì?</h3>
Bạn không cần thực hiện bất kỳ thao tác thủ công nào. Tất cả thông tin tài khoản, hạn mức và lịch sử khoản vay của bạn đã được đồng bộ hóa an toàn sang hệ thống mới của VIB AMC.
- Bằng việc tiếp tục sử dụng ứng dụng, bạn xác nhận đồng ý với việc chuyển giao dữ liệu này.
- Nếu bạn không đồng ý với việc di chuyển dữ liệu sang pháp nhân mới, bạn có quyền yêu cầu ngừng dịch vụ và xóa dữ liệu cá nhân thông qua mục "Hủy tài khoản" hoặc liên hệ email: service@lavifinance.com.
   
<h2> Chính sách bảo mật</h2>
    Trong phạm vi được luật hiện hành yêu cầu, bất cứ khi nào Ứng dụng thu thập thông tin cá nhân, Ứng dụng sẽ:
    
     1. Cung cấp cho bạn tuyên bố về quyền riêng tư kịp thời và phù hợp về việc xử lý dữ liệu cá nhân
  
     2. Thông tin cá nhân được thu thập cho các mục đích được nêu trong tuyên bố về quyền riêng tư này. Thông tin chúng tôi thu thập có liên quan, phù hợp và không vượt quá mục đích thu thập
  
     3. Ứng dụng này xử lý dữ liệu cá nhân của bạn theo cách phù hợp với mục đích thu thập ban đầu hoặc với sự đồng ý của bạn
  
     4. Ứng dụng này thực hiện các biện pháp thích hợp để đảm bảo rằng thông tin cá nhân của bạn là đáng tin cậy, chính xác, đầy đủ, cập nhật và phù hợp với mục đích dự định của nó
    
<h2>Dữ liệu cá nhân chúng tôi có thể thu thập từ bạn</h2>
 Lavi Finance (vận hành bởi VIB AMC) cam kết chỉ thu thập các dữ liệu cần thiết nhằm phục vụ mục đích định danh, đánh giá tín dụng và bảo mật tài khoản. Dưới đây là chi tiết các thông tin chúng tôi thu thập:

 <h3> 1. Thông tin định danh và Hình ảnh (KYC)</h3>
- Mô tả: Chúng tôi yêu cầu bạn cung cấp ảnh chụp giấy tờ tùy thân (CCCD/CMND) và ảnh chân dung thực tế.
- Mục đích: Để thực hiện quy trình định danh điện tử (eKYC), xác minh bạn chính là người đang thực hiện yêu cầu vay vốn, ngăn chặn các hành vi giả mạo danh tính.
- Cam kết: Thông tin này được mã hóa và truyền an toàn tới máy chủ https://www.lavifinance.com. Chúng tôi không chia sẻ hình ảnh này với bất kỳ bên thứ ba nào khi chưa có sự đồng ý của bạn.

<h3> 2. Danh bạ liên lạc</h3>
- Mô tả: Sau khi được bạn cho phép, ứng dụng sẽ thu thập thông tin danh bạ (bao gồm tên và số điện thoại).
- Mục đích: Để phục vụ việc đánh giá điểm tín dụng và xác minh tham chiếu trong quá trình xét duyệt hồ sơ. Đây là một phần quan trọng để chúng tôi đưa ra hạn mức vay phù hợp cho bạn.
- Cam kết: Lavi Finance chỉ tải dữ liệu lên https://www.lavifinance.com khi bạn xác nhận đồng ý. Chúng tôi tuyệt đối không sử dụng danh bạ của bạn cho mục đích làm phiền hay tiếp thị trái phép. 

<h3> 3. Thông tin vị trí (GPS)</h3>
- Mô tả: Chúng tôi thu thập thông tin về vị trí địa lý của thiết bị khi bạn sử dụng ứng dụng.
- Mục đích: Để đảm bảo bạn đang thực hiện giao dịch tại lãnh thổ Việt Nam (khu vực dịch vụ được hỗ trợ) và hỗ trợ phát hiện các truy cập bất thường từ các vị trí xa lạ nhằm bảo vệ tài khoản của bạn khỏi gian lận.
- Cam kết: Dữ liệu vị trí chỉ được thu thập khi có sự đồng ý của bạn và được bảo mật tuyệt đối qua kết nối HTTPS.

<h3> 4. Quyền truy cập Máy ảnh (Camera)</h3>
- Mô tả: Ứng dụng cần quyền sử dụng máy ảnh để chụp ảnh giấy tờ và nhận diện khuôn mặt.
- Mục đích: Đảm bảo tính xác thực của các hồ sơ tải lên và phục vụ tính năng nhận diện sinh trắc học, giúp quá trình đăng ký diễn ra nhanh chóng và chính xác.
- Cam kết: Máy ảnh chỉ được kích hoạt khi bạn thực hiện các thao tác định danh trong ứng dụng.

<h3> 5. Mã nhận dạng quảng cáo (IDFA/AAID)</h3>
- Mô tả: Chúng tôi thu thập mã định danh thiết bị để theo dõi hiệu suất và tương tác của người dùng.
- Mục đích: Giúp Lavi Finance nhận diện thiết bị tin cậy, ngăn chặn việc sử dụng phần mềm giả lập để gian lận và đề xuất các sản phẩm tài chính phù hợp nhất với nhu cầu của bạn.
- Cam kết: Mọi dữ liệu liên quan đến mã định danh đều được mã hóa và gửi về hệ thống quản lý rủi ro nội bộ tại https://www.lavifinance.com.

<h3> 6. Quyền truy cập Micrô (Microphone)</h3>
- Mô tả: Quyền sử dụng micrô được yêu cầu khi thực hiện quy trình xác thực "người thật" (Liveness Detection).
- Mục đích: Để xác minh video quay trực tiếp không phải là hình ảnh tĩnh hoặc video giả mạo, từ đó tăng tốc độ phê duyệt hồ sơ tự động.
- Cam kết: Chúng tôi chỉ sử dụng quyền này trong quá trình định danh và không ghi âm các cuộc hội thoại riêng tư của bạn.
    
    <h2> Dữ liệu cá nhân của bạn sẽ được lưu giữ trong bao lâu?</h2>
    Theo yêu cầu của luật hiện hành, đặc biệt là các luật liên quan đến phòng chống rửa tiền, chúng tôi sẽ lưu giữ dữ liệu của bạn trong mười năm kể từ ngày giao dịch hoặc lâu hơn nếu đáp ứng các khoảng thời gian lưu giữ sau;
    Sau khi hủy tài khoản của bạn, chúng tôi sẽ lưu trữ tất cả dữ liệu liên quan đến tài khoản của bạn, bao gồm dữ liệu cá nhân và dữ liệu giao dịch, trong tối đa 5 năm kể từ ngày hủy và sau đó xóa vĩnh viễn tài khoản đó.
    Bạn có thể xóa thông tin tài khoản của mình trực tiếp thông qua liên kết "Xóa tài khoản" tại đây để chúng tôi có thể xóa vĩnh viễn tất cả thông tin cá nhân của bạn.
    Chúng tôi có thể lưu giữ dữ liệu cá nhân của bạn trong thời gian dài hơn nếu có khiếu nại hoặc nếu chúng tôi có lý do để tin rằng kiện tụng hoặc hành động quản lý hoặc thực thi khác có thể phát sinh liên quan đến mối quan hệ của chúng tôi với bạn và/hoặc việc bạn sử dụng Dịch vụ.
    
    <h2>Mục đích thu thập dữ liệu cá nhânv</h2>
    Lavi Finance sử dụng dữ liệu cá nhân của bạn cho các mục đích sau:
    Danh tính của người nộp đơn và/hoặc khách hàng (tùy từng trường hợp).
    Tạo file thông tin khách hàng.
    Quản lý, kiểm soát, quản lý và xử lý đơn xin tín dụng và cấp tín dụng khi thích hợp.
    Quản lý, kiểm soát và thực thi các hợp đồng tín dụng với khách hàng.
    Quản lý, kiểm soát và thực thi các khoản thu hành chính, ngoài tư pháp và (nếu có) tư pháp nhận được từ các dịch vụ do Lavi Finance cung cấp.
    Phân tích những thay đổi trong hồ sơ giao dịch của khách hàng.
    Tuân thủ các nghĩa vụ về thuế và kinh doanh.
    Giải quyết các câu hỏi, mối quan tâm, làm rõ hoặc khiếu nại của khách hàng.
    Thống kê và lịch sử người dùng và khách hàng.
    Tạo, duy trì và đào tạo các mô hình dự đoán rủi ro của Lavi Finance.
    Duy trì thông tin và bảo mật hoạt động.
    Ngăn chặn hành vi trộm cắp danh tính.

    <h2> Lưu giữ và xóa dữ liệu</h2>
    Lavi Finance cam kết sử dụng các biện pháp bảo mật thích hợp để bảo vệ dữ liệu cá nhân của bạn khỏi bị truy cập trái phép, lạm dụng và tiết lộ, tùy thuộc vào loại dữ liệu và cách chúng tôi xử lý dữ liệu đó. Chúng tôi lưu giữ thông tin về bạn để mang đến cho bạn trải nghiệm suôn sẻ và liên hệ với bạn nếu bạn cần hỗ trợ; chúng tôi lưu giữ thông tin về tài khoản của bạn để phát hiện, giảm thiểu, ngăn chặn và điều tra hoạt động gian lận hoặc bất hợp pháp. Chúng tôi sẽ lưu giữ dữ liệu của bạn trong khoảng thời gian cần thiết để cung cấp cho bạn các dịch vụ của chúng tôi. Chúng tôi cũng có thể lưu giữ và sử dụng thông tin cá nhân của bạn khi cần thiết để tuân thủ các nghĩa vụ pháp lý, giải quyết tranh chấp và thực thi các thỏa thuận của chúng tôi. Theo phần này, chúng tôi có thể xóa dữ liệu của bạn theo yêu cầu bằng văn bản hợp lý. Tuy nhiên, bạn có thể không sử dụng được dịch vụ của chúng tôi sau khi xóa.
    
    <h2> Hủy tài khoản</h2>
    Hủy tài khoản là một hoạt động không thể đảo ngược. Trước khi giao dịch, vui lòng xác nhận rằng tất cả các dịch vụ liên quan đến tài khoản đã được xử lý bình thường. Xin lưu ý rằng sau khi hủy tài khoản, bạn sẽ không thể sử dụng bất kỳ dịch vụ nào liên quan đến sản phẩm này nữa. Đồng thời, việc hủy tài khoản không có nghĩa là hành vi của tài khoản và các trách nhiệm liên quan trước khi hủy được miễn hoặc giảm bớt. Nếu bạn quyết định hủy tài khoản của mình, vui lòng liên hệ với chúng tôi qua email tại service@lavifinance.com và chúng tôi sẽ xử lý yêu cầu trong vòng 7 ngày làm việc.
    
    <h2> quyền của bạn</h2>
    Chúng tôi sẽ sử dụng dữ liệu của bạn để tổng hợp số liệu thống kê liên quan đến cơ sở người dùng hoặc danh mục cho vay của chúng tôi và có thể tiết lộ thông tin đó cho bên thứ ba vì các mục đích đó, miễn là thông tin đó luôn ẩn danh.
    
    <h2> Liên hệ với chúng tôi</h2>
    Nếu bạn có bất kỳ câu hỏi hoặc đề xuất nào về chính sách quyền riêng tư này, vui lòng liên hệ với chúng tôi:
    Email: service@lavifinance.com
    Dịch vụ khách hàng: Thứ Hai đến Thứ Sáu, 9 giờ sáng đến 5 giờ chiều.
    Địa chỉ công ty: 4 Ton That Tung Street, Coninco Tower Building, Floor 12, Kim Lien Ward Vietnam
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import importedImg1 from "@/page/lavifinancecompany/components/img/privacyBanner.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      text:``
    };
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #FFFFFF;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3F4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  /* margin-top: 50px; */
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}
.textBox h2{
  font-size: 35px;
  font-weight: 700;
  margin-top: 20px;
}

.textBox h3{
  margin-top: 20px;
  font-size: 25px;
  font-weight: 500;
}


.imgBox2 {
  /* transform: scale(90%); */
  transform: scale(90%);
  margin: -220px auto 0;
  height: 5100px;
  /* box-shadow:0 2px 8px rgba(0, 0, 0, 0.25); */
}

.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0BAF60;
  margin: 0 500px;
}

.img1 {
  /* margin-top: 50px; */
  /* padding: 0 200px; */
}
</style>